/* eslint-disable react/no-unescaped-entities, react/jsx-key */
import { motion } from "framer-motion";
import { Smartphone, Tablet, Monitor, ExternalLink } from "lucide-react";

const devices = [
  { icon: Smartphone, label: "Téléphone", w: "w-20", h: "h-32", note: "78 % du trafic local" },
  { icon: Tablet, label: "Tablette", w: "w-28", h: "h-36", note: "9 % du trafic" },
  { icon: Monitor, label: "Ordinateur", w: "w-44", h: "h-32", note: "13 % du trafic" },
];

export const Responsive = () => (
  <section id="multi-device" data-testid="responsive-section" className="py-24 md:py-32 bg-paper-soft border-y border-ink/5">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <p className="font-mono-label text-cyan-600 flex items-center">
            <span className="rule bg-cyan" /> Sur tous les écrans
          </p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-ink tracking-tight leading-[1.05]">
            Un site <em className="italic font-light">parfait</em>{" "}
            sur téléphone, tablette et ordinateur.
          </h2>
          <p className="mt-8 text-ink/75 leading-relaxed text-lg">
            Votre site s'adapte <strong className="text-ink">automatiquement</strong> à
            chaque écran. Vos visiteurs le lisent confortablement, où qu'ils
            soient.
          </p>
          <p className="mt-5 text-sm text-ink/60 leading-relaxed">
            La majorité de vos clients arrivent par mobile — c'est notre
            priorité n°1.
          </p>
          <p className="mt-6 text-xs text-ink/45 flex items-center gap-1.5">
            <ExternalLink size={11} /> Source : Google Mobile-First Indexing, StatCounter France 2025.
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="relative bg-white border border-ink/10 p-8 md:p-12 overflow-hidden">
            <div className="absolute -top-12 -right-12 w-60 h-60 bg-cyan/15 rounded-full blur-3xl" aria-hidden />

            <div className="flex items-end justify-center gap-6 md:gap-10 relative">
              {devices.map((d, i) => {
                const Icon = d.icon;
                return (
                  <motion.div
                    key={d.label}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.15 }}
                    className="flex flex-col items-center"
                    data-testid={`device-${d.label.toLowerCase()}`}
                  >
                    <div className={`${d.w} ${d.h} border-2 border-ink rounded-md bg-gradient-to-br from-ink to-ink-700 relative shadow-[0_20px_50px_-25px_rgba(11,30,61,0.5)] overflow-hidden`}>
                      <div className="absolute inset-1 bg-paper-soft rounded-sm flex flex-col">
                        <div className="h-2 bg-gradient-to-r from-ink/80 via-cyan-600 to-ink/80" />
                        <div className="flex-1 p-1.5 space-y-1">
                          <div className="h-1.5 bg-ink/15 rounded-full w-3/4" />
                          <div className="h-1.5 bg-ink/15 rounded-full w-1/2" />
                          <div className="h-3 bg-gradient-to-r from-cyan-400 to-cyan-600 rounded-sm mt-2" />
                          <div className="h-1 bg-ink/10 rounded-full w-full mt-2" />
                          <div className="h-1 bg-ink/10 rounded-full w-2/3" />
                        </div>
                      </div>
                    </div>
                    <Icon size={18} className="mt-5 text-cyan-600" />
                    <p className="mt-2 font-mono-label text-ink/70">{d.label}</p>
                    <p className="mt-1 text-xs text-ink/50">{d.note}</p>
                  </motion.div>
                );
              })}
            </div>

            <div className="mt-10 grid grid-cols-3 gap-3 text-center">
              <div className="p-3 bg-paper-soft">
                <p className="font-display text-2xl text-ink">100 %</p>
                <p className="font-mono-label text-ink/55 mt-1">Mobile</p>
              </div>
              <div className="p-3 bg-paper-soft">
                <p className="font-display text-2xl text-ink">100 %</p>
                <p className="font-mono-label text-ink/55 mt-1">Tablette</p>
              </div>
              <div className="p-3 bg-paper-soft">
                <p className="font-display text-2xl text-ink">100 %</p>
                <p className="font-mono-label text-ink/55 mt-1">Desktop</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
